/**
 * Tiny wrapper around Google Analytics 4 gtag() so callers don't need to
 * null-check window.gtag every time.
 */
export const track = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch {
    // never let analytics break the app
  }
};
